(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["space-outfit-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('space-outfit')) {
    customElements.define('space-outfit', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = this.querySelector('[data-outfit-form]');
        const button = form?.querySelector('button[type="submit"]');
        if (!button) return;
        const selects = [...form.querySelectorAll('select')];
        const status = this.querySelector('[role="status"]');
        const cartLink = this.querySelector('.space-outfit-card__cart');
        const total = this.querySelector('[data-total]');
        const totalRow = this.querySelector('.space-outfit-card__total');
        const selected = () => selects.filter(select => select.value && !select.disabled);
        const update = () => {
          const choices = selected();
          button.disabled = this.busy || choices.length === 0;
          const cents = choices.reduce((sum, select) => sum + Number(select.selectedOptions[0].dataset.price), 0);
          total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: form.dataset.currency || 'EUR' }).format(cents / 100);
          totalRow.hidden = choices.length === 0;
        };
        form.addEventListener('change', update);
        update();
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.busy) return;
          const choices = selected();
          if (!choices.length) { status.textContent = form.dataset.empty; return; }
          this.busy = true;
          button.setAttribute('aria-busy', 'true');
          status.textContent = '';
          cartLink.hidden = true;
          update();
          try {
            const response = await fetch(form.action + '.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: choices.map(select => ({ id: Number(select.value), quantity: 1 })) })
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(form.dataset.error);
            window.location.assign(form.dataset.cartUrl);
          } catch (error) {
            status.textContent = form.dataset.error;
            cartLink.hidden = false;
            this.busy = false;
            button.removeAttribute('aria-busy');
            update();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["space-pants-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('space-pants-filter')) {
  customElements.define('space-pants-filter', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.sectionId = this.getAttribute('section-id');
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      const signal = this.controller.signal;
      document.addEventListener('facet:update', event => this.preserveFit(event), { capture: true, signal });
      this.addEventListener('click', event => {
        const remove = event.target.closest('[data-space-fit-remove]');
        if (remove) this.removeFit(remove.dataset.spaceFitRemove);
        if (event.target.closest('[data-space-fit-clear]')) this.removeFit();
      }, { signal });
      window.addEventListener('popstate', () => this.renderResults(), { signal });
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const url = new URL(window.location.href);
        const legacy = url.searchParams.get('filter.p.m.custom.vestibilita');
        if (legacy) {
          url.searchParams.delete('filter.p.m.custom.vestibilita');
          if (legacy === 'Regular' && !url.searchParams.has('space_fit')) url.searchParams.append('space_fit', 'regular');
          this.update(url);
        } else {
          this.renderResults();
        }
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.section?.classList.remove('space-pants-enhanced');
    }

    inputs() {
      return [...document.querySelectorAll(`input[id^="space-fit-${this.sectionId}-"]`)];
    }

    preserveFit(event) {
      const url = event.detail?.url;
      if (!url || url.searchParams.get('section_id') !== this.sectionId) return;
      const current = new URL(window.location.href);
      url.searchParams.delete('filter.p.m.custom.vestibilita');
      if (event.target.tagName === 'FACET-LINK' && !event.target.hasAttribute('data-space-clear-all') && !event.target.querySelector('.facets-clear-all') && !url.searchParams.has('space_fit')) {
        current.searchParams.getAll('space_fit').forEach(value => url.searchParams.append('space_fit', value));
      }
      if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    }

    fitKey(label) {
      if (label.includes('fondo svasato')) return 'flare';
      return label.toLowerCase().replaceAll(' ', '-');
    }

    renderResults() {
      if (!this.section) return;
      const inputs = this.inputs();
      const labels = new Map(inputs.map(input => [input.value, input.dataset.spaceFitLabel]));
      const selected = new Set(new URL(window.location.href).searchParams.getAll('space_fit').filter(value => labels.has(value)));
      const cards = [...this.section.querySelectorAll('product-list > product-card[data-space-pants-fit]')];
      const counts = new Map();
      let visible = 0;
      cards.forEach(card => {
        const key = this.fitKey(card.dataset.spacePantsFit);
        counts.set(key, (counts.get(key) || 0) + 1);
        card.hidden = selected.size > 0 && !selected.has(key);
        if (!card.hidden) visible += 1;
      });
      inputs.forEach(input => {
        const count = counts.get(input.value) || 0;
        input.checked = selected.has(input.value);
        input.disabled = count === 0 && !input.checked;
        input.parentElement.querySelector('[data-space-fit-count]').textContent = `(${count})`;
        if (input.checked) input.closest('details')?.setAttribute('open', '');
      });
      this.section.classList.add('space-pants-enhanced');
      const active = this.querySelector('[data-space-fit-active]');
      active.replaceChildren();
      selected.forEach(value => {
        const pill = document.createElement('div');
        pill.className = 'removable-facet';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tap-area link-faded';
        button.dataset.spaceFitRemove = value;
        button.setAttribute('aria-label', this.dataset.removeLabel.replace('__name__', labels.get(value)));
        button.textContent = '×';
        const label = document.createElement('span');
        label.className = 'text-subdued';
        label.textContent = labels.get(value);
        pill.append(button, label);
        active.append(pill);
      });
      active.hidden = selected.size === 0;
      const result = this.querySelector('[data-space-fit-results]');
      result.textContent = this.dataset.countLabel.replace('__count__', visible);
      result.hidden = false;
      this.querySelector('[data-space-fit-empty]').hidden = visible !== 0 || cards.length === 0;
      const filterButton = this.section.querySelector('[aria-controls="facets-drawer"]');
      const totalFilters = Number(this.dataset.nativeCount) + selected.size;
      if (filterButton) filterButton.textContent = `${this.dataset.filterLabel}${totalFilters ? ` (${totalFilters})` : ''}`;
    }

    removeFit(value) {
      const url = new URL(window.location.href);
      const kept = value ? url.searchParams.getAll('space_fit').filter(fit => fit !== value) : [];
      url.searchParams.delete('space_fit');
      kept.forEach(fit => url.searchParams.append('space_fit', fit));
      this.update(url);
    }

    update(url) {
      url.searchParams.delete('page');
      url.searchParams.set('section_id', this.sectionId);
      this.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url } }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
